export default __webpack_public_path__ + "static/media/imageeight.2fa62b67.gif";